// ABOUTME: The v28 tracker row: back arrow, five decorative bars coloured by pill state, forward arrow.
// ABOUTME: Phase names and states are spoken from a visually hidden ordered list; none are drawn (Issues #1940, #2045, #2175).

import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import type { CrossingPill } from '../../../types/api';
import { TRACKER_BAR_COLORS } from '../../../theme/crossingTokens';
import { visuallyHidden } from '../runner/visuallyHidden';

interface TrackerProps {
  pills: CrossingPill[];
  backArrow?: ReactNode;
  forwardArrow?: ReactNode;
  // Removes the bars and the spoken list (the entry tour); the arrows stay.
  hidden?: boolean;
}

export default function Tracker({ pills, backArrow, forwardArrow, hidden }: TrackerProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
      {backArrow}
      {!hidden && (
        <>
          <Box aria-hidden="true" sx={{ flex: 1, display: 'flex', gap: '5px' }}>
            {pills.map(pill => (
              <Box
                key={pill.number}
                data-testid="tracker-bar"
                data-state={pill.state}
                sx={{
                  flex: 1,
                  height: '5px',
                  borderRadius: '3px',
                  backgroundColor: TRACKER_BAR_COLORS[pill.state],
                  transition: 'background-color 0.4s ease',
                }}
              />
            ))}
          </Box>
          <Box
            component="ol"
            // list-style: none removes the list semantics in Safari/VoiceOver unless the role is explicit.
            role="list"
            aria-label="Crossing progress"
            sx={visuallyHidden}
          >
            {pills.map(pill => (
              <Box component="li" key={pill.number} aria-current={pill.state === 'current' ? 'step' : undefined}>
                {`${pill.name}, ${pill.stateLabel}`}
              </Box>
            ))}
          </Box>
        </>
      )}
      {forwardArrow}
    </Box>
  );
}
